/* eslint-disable no-unused-vars */
export enum Permission {
  HOME = 'admin',
  DOCUMENTS = 'documents',
  TAX_FORMS = 'tax_forms',
  HR_PROFILE = 'hr_profile',
  HELP_SUPPORT = 'help_support',
  PAY_HISTORY = 'pay_history',
  BENEFITS = 'benefits',
  INVOICE = 'invoice',
  Expense = 'expense',
  LEAVE = 'leave',
}
